export const UserOptionsTR={
UsOpID:{en:'UsOpID',cs:'UsOpID',dataType:'number',format:'#0',required:true},
UsOpUserID:{en:'UsOpUserID',cs:'UsOpUserID',dataType:'number',format:'#0',required:true},
UsOpTimeStamp:{en:'UsOpTimeStamp',cs:'UsOpTimeStamp',dataType:'number',format:'#0'},
UsOpJsonObject:{en:'UsOpJsonObject',cs:'UsOpJsonObject',dataType:'string'}
}